import { useLocation } from 'react-router-dom';
import { MenuItem } from '@isocel/front-common/dist/components/MainMenu';
import { Dashboard, FlowFour, FlowOne, FlowThree, FlowTwo, Scanner, Transfer } from '@isocel/front-common';

import { Permission } from '../queries/api/types';
import { getRoute, RoutePathName } from '../routes';

export const menuItems: MenuItem[] = [
    {
        key: getRoute(RoutePathName.dashboard),
        to: getRoute(RoutePathName.dashboard),
        label: 'Tableau de bord',
        icon: <Dashboard />,
        permission: Permission.dashboard,
    },
    {
        key: getRoute(RoutePathName.afterLoading),
        to: getRoute(RoutePathName.afterLoading),
        label: 'Expédition vers magasin',
        icon: <FlowOne />,
        permission: Permission.orgUser,
    },
    {
        key: getRoute(RoutePathName.receptionStore),
        to: getRoute(RoutePathName.receptionStore),
        label: 'Réception en magasin',
        icon: <FlowTwo />,
        permission: Permission.storeUser,
    },
    {
        key: getRoute(RoutePathName.recipient),
        to: getRoute(RoutePathName.recipient),
        label: "Expédition retour d'emballages",
        icon: <FlowThree />,
        permission: Permission.storeUser,
    },
    {
        key: getRoute(RoutePathName.receptionInfo),
        to: getRoute(RoutePathName.receptionInfo),
        label: "Réception de retour d'emballages",
        icon: <FlowFour />,
        permission: Permission.orgUser,
    },
    {
        key: getRoute(RoutePathName.palettCreate),
        to: getRoute(RoutePathName.palettCreate),
        label: 'Mouvements divers',
        icon: <Transfer />,
        permission: Permission.orgUser,
    },
    {
        key: getRoute(RoutePathName.qrParcs),
        to: getRoute(RoutePathName.qrParcs),
        label: "Rendu d'emballages au transporteur",
        icon: <Scanner />,
        permission: Permission.orgUser,
    },
];

export const getSelectedKey = (location: ReturnType<typeof useLocation>) => {
    // Find the menu item whose 'to' matches the current pathname
    const item = menuItems.find((item) => 'to' in item && item.to === location.pathname);
    return item ? item.key : '';
};
